const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const DamageEvent = require('../../events/DamageEvent');
const BleedingCondition = require('../../conditions/BleedingCondition');
const { logError } = require('../../logger');

const RazorShot = function (battleState) {
  this.handle = 'razor_shot';
  this.physical = true;
  this.bow = true;
  this.ranged = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return (
      victim.unit &&
      actor.equipment.off_hand &&
      actor.equipment.off_hand.type === 'bow'
    );
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    const ability = BattleCalc.getEquippedAbility(actor, this.handle);

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        const result = this.standardStrike.execute(
          actor,
          victim,
          ability.damage,
          true
        );
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;

        if (result.success && !victim.dead) {
          // calculate bleed condition potency using a dummy damage event,
          // so we can apply stance adjustments, hero Affinities, etc.
          const bleedDamageDummy = new DamageEvent(
            battleState,
            actor,
            ability.potency,
            this
          );
          bleedDamageDummy.applyStanceAdjustments(victim);
          const bleed_potency = bleedDamageDummy.damage;

          // if the victim already has a bleeding condition with same instigator, add to its potency
          let bleeding = BattleCalc.getCondition(victim, 'bleeding', actor.uid);
          if (bleeding) {
            bleeding.potency += bleed_potency;
            battleState.updateCondition(victim.uid, bleeding.uid);
            result.bleeding = bleeding;
          } else {
            bleeding = new BleedingCondition(
              actor,
              victim,
              battleState,
              bleed_potency
            );
            battleState.onUnitCondition(bleeding);
            result.bleeding = bleeding;
          }
        }

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'RazorShot',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim));
  };
};
module.exports = RazorShot;
